var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 11.6667C11.7885 11.6667 12.8332 10.622 12.8332 9.33333C12.8332 8.04467 11.7885 7 10.4998 7C9.21117 7 8.1665 8.04467 8.1665 9.33333C8.1665 10.622 9.21117 11.6667 10.4998 11.6667Z",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 2.33331H10.5002C4.66683 2.33331 2.3335 4.66665 2.3335 10.5V17.5C2.3335 23.3333 4.66683 25.6666 10.5002 25.6666H17.5002C23.3335 25.6666 25.6668 23.3333 25.6668 17.5V11.6666",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.33331V2.33331L23.3333 4.66665",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 2.33331L18.6665 4.66665",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11475 22.1083L8.86641 18.2467C9.78808 17.6283 11.1181 17.6983 11.9464 18.41L12.3314 18.7483C13.2414 19.53 14.7114 19.53 15.6214 18.7483L20.4747 14.5833C21.3847 13.8017 22.8547 13.8017 23.7647 14.5833L25.6664 16.2167",
    stroke: "#B90022",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryred);
export default __webpack_public_path__ + "static/media/galleryred.019de1e6be81acddd7cb1e54f942f12c.svg";
export { ForwardRef as ReactComponent };